import {
  PayeeRequirement,
  PayeeRequirementExpirationStatus
} from "@wingspanhq/wingspan-api-sdk";

export const selectorIsRequirementExpiringSoon = (
  requirement: PayeeRequirement
) => {
  return (
    requirement.expirationStatus === PayeeRequirementExpirationStatus.EXPIRING
  );
};
